import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';

$(() => {
  const instantBidConfirmButton = $('.instant-bid-confirm-button');
  const newBidDisplayElement = $('#bid-amount');

  const onInstantBidConfirmed = () => {
    const newBidString = newBidDisplayElement.attr('data-bid-value');
    const bidValue = parseInt(newBidString);
    EVENT_BUS.dispatch(AUCTION_EVENTS.INSTANT_BID_CONFIRMED, { bidValue });
  };

  instantBidConfirmButton.on('click', onInstantBidConfirmed);

  $(window).on('unload', () => {
    instantBidConfirmButton.off('click', onInstantBidConfirmed);
  });
});
